export const version = { shortSHA: 'd10f4cf7' };
